var exports = {
  "jD": "x31de4314--6658f8--cont",
  "ne": "x31de4314--6658f8--controls",
};

module.exports = exports;
